import React from "react";

export const IconLine = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15.545"
            height="15.545"
            viewBox="0 0 15.545 15.545"
        >
            <g id="menu" transform="translate(-8.227 -2.227)">
                <line
                    id="Line_51"
                    data-name="Line 51"
                    y1="13"
                    x2="13"
                    transform="translate(9.5 3.5)"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeWidth="1.8"
                />
            </g>
        </svg>
    );
};
